import { useCallback } from 'react';

export function useScrollToTop() {
  return useCallback((node = window) => {
    node.scrollTo(0, 0);
  }, []);
}
